import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getMyPermissions } from '../services/api';

interface ProtectedRouteProps {
    children: JSX.Element;
    requiredPermission: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermission }) => {
    const [permissions, setPermissions] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const token = localStorage.getItem('access_token');

    useEffect(() => {
        const fetchPermissions = async () => {
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const perms = await getMyPermissions();
                setPermissions(perms);
            } catch (error) {
                console.error('Failed to fetch permissions', error);
                setPermissions({});
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [token]);

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '1rem',
                color: '#64748b'
            }}>
                Loading...
            </div>
        );
    }

    // Check if user has the required permission
    if (permissions && !permissions[requiredPermission]) {
        // Redirect to dashboard or show access denied
        return (
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                gap: '1rem'
            }}>
                <div style={{ fontSize: '3rem' }}>🔒</div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1e293b', margin: 0 }}>Access Denied</h2>
                <p style={{ fontSize: '1rem', color: '#64748b', margin: 0 }}>
                    You don't have permission to access this page.
                </p>
                <a 
                    href="/" 
                    style={{ 
                        marginTop: '1rem',
                        padding: '0.75rem 1.5rem',
                        backgroundColor: '#4285f4',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '8px',
                        fontWeight: '500'
                    }}
                >
                    Go to Dashboard
                </a>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;
